export * from './opportunities'

/**
 * Ordena items de um filtro com base no valor da chave passada no parâmetro
 * @param {object} a Objeto que será comparado para ordenação
 * @param {object} b Objeto que será comparado para ordenação
 * @param {string} key String que representa um chave no objeto pelo qual os seus valores serão ordenados
 *
 * @returns array ordenado de forma crescente pelo @param key
 */
export const sortFilterItemsAscendingByKey = key => (a, b) =>
  +(a[key] > b[key]) || +(a[key] === b[key]) - 1

export const getFilterItems = (state, key) => {
  const defaultReturn = []
  if (typeof state !== 'object' || !state || !state.Filters)
    return defaultReturn

  const filter = state.Filters.find(filterGroup => filterGroup.name === key)

  if (!filter) return defaultReturn

  return filter.items || defaultReturn
}
